import type { ResolutionTargetLiteral, ResolveRow } from "./resolveWithValue.helpers";

import { formatFieldValue } from "./DiscrepancyReviewDialog.helpers";
import { copiesLeftDisagreeing, type CopyKey } from "./resolveWithValue.outcome";

const COPY_SUBJECTS: Record<CopyKey, string> = {
  vendor: "Vendor",
  eManifest: "e-Manifest",
  document: "The manifest document",
};

export interface CopyWarningOpts {
  row: ResolveRow;
  answerValue: string;
  writesVendor: boolean;
  writesEManifest: boolean;
  writesDocument: boolean;
}

function currentValueOf(row: ResolveRow, copy: CopyKey): string | null | undefined {
  if (copy === "vendor") return row.vendorValue;
  if (copy === "eManifest") return row.eManifestValue;
  return row.manifestDocumentValue;
}

function warningFor(copy: CopyKey, row: ResolveRow, writesEManifest: boolean): string {
  const still = `${COPY_SUBJECTS[copy]} still says ${formatFieldValue(row.field, currentValueOf(row, copy))}`;
  if (writesEManifest)
    return `${still}. When e-Manifest is corrected, this row goes back to Pending Review.`;
  return `${still}, and this field can't be corrected there, so this row stays Pending Review.`;
}

/** One line per copy that still disagrees with the answer after the writes. */
export function copyWarningMessages(opts: CopyWarningOpts): string[] {
  const { row, answerValue, writesVendor, writesEManifest, writesDocument } = opts;
  const applyTo: ResolutionTargetLiteral[] = [];
  if (writesVendor) applyTo.push("VENDOR_DATA");
  if (writesEManifest) applyTo.push("EMANIFEST");
  if (writesDocument) applyTo.push("DOCUMENT");
  return copiesLeftDisagreeing(row, answerValue, applyTo).map((copy) =>
    warningFor(copy, row, writesEManifest)
  );
}
